import React, { useState } from 'react';
import { BookOpen } from 'lucide-react';
import { PrivacyPolicyPopup } from './PrivacyPolicyPopup';
export function Footer() {
  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);
  return <footer className="w-full bg-gray-900 text-white py-10 px-4 border-t border-amber-900" data-id="element-52">
      <div className="max-w-5xl mx-auto" data-id="element-53">
        <div className="flex flex-col items-center justify-center mb-8" data-id="element-54">
          <div className="flex items-center mb-4" data-id="element-55">
            <BookOpen size={24} className="text-amber-400 mr-2" data-id="element-56" />
            <h3 className="text-xl font-semibold text-amber-400" data-id="element-57">
              The Charlie Kirk Method
            </h3>
          </div>
          <p className="text-gray-300 text-center max-w-2xl" data-id="element-58">
            This program is designed for educational purposes. Results may vary
            based on individual effort and application of the principles taught.
          </p>
        </div>
        <div className="border-t border-gray-800 pt-6 text-center" data-id="element-59">
          <p className="text-sm text-gray-400" data-id="element-60">
            © {new Date().getFullYear()} The Charlie Kirk Method. All rights
            reserved.
          </p>
          <div className="flex justify-center mt-4" data-id="element-61">
            <button onClick={() => setIsPrivacyPolicyOpen(true)} className="text-amber-300 hover:text-amber-400 transition" data-id="element-62">
              Privacy Policy
            </button>
          </div>
        </div>
      </div>
      <PrivacyPolicyPopup isOpen={isPrivacyPolicyOpen} onClose={() => setIsPrivacyPolicyOpen(false)} data-id="element-63" />
    </footer>;
}